import 'whatwg-fetch';
import "babel-polyfill";
import {h, render} from 'preact';

import FedListFront from "./src/FedListFront.jsx";

render(<FedListFront/>, document.getElementById('FedListFront'));
